<div class="preview-modal-container">
    <!-- Header -->
    <div class="preview-modal-header" fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
            <mat-icon class="header-icon">{{ data.isPdf ? 'picture_as_pdf' : 'image' }}</mat-icon>
            <span class="preview-modal-title" [matTooltip]="data.fileName" matTooltipPosition="below">
                {{ data.fileName | truncateFilename: 40 }}
            </span>
        </div>
        <button mat-icon-button (click)="close()" class="close-btn" disableRipple>
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Body -->
    <div class="preview-modal-body">
        <!-- Loading state -->
        <!-- Loader shown while safeUrl is being prepared (primarily for PDFs fetched on-demand) -->
        <div *ngIf="!safeUrl" class="preview-loading" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="16px">
            <mat-spinner [diameter]="48"></mat-spinner>
            <span class="loading-text">{{ 'DOC_PREVIEW.LOADING_DOCUMENT' | translate }}...</span>
        </div>

        <!-- PDF preview -->
        <iframe
            *ngIf="safeUrl && data.isPdf"
            [src]="safeUrl"
            class="preview-iframe"
            frameborder="0"
            allow="fullscreen"
            [title]="data.fileName"
        ></iframe>

        <!-- Image preview -->
        <div *ngIf="safeUrl && !data.isPdf" class="image-preview-wrapper" fxLayout="column" fxLayoutAlign="center center">
            <img [src]="safeUrl" [alt]="data.fileName" class="preview-image" />
        </div>
    </div>
</div>
